import React from 'react';
import { ErrorHandler } from '../errors';

interface ErrorDisplayProps {
  error: unknown;
  onDismiss?: () => void;
}

export const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ error, onDismiss }) => {
  const apiError = ErrorHandler.handle(error);

  // Format details if they exist and are not just an object string
  let details: string | null = null;
  if (apiError.error.details) {
    // Only show details if it's not just 'originalError'
    const keys = Object.keys(apiError.error.details);
    if (!(keys.length === 1 && keys[0] === 'originalError')) {
      try {
        details = JSON.stringify(apiError.error.details, null, 2);
        if (details === '"[object Object]"' || details === '{}') details = null;
      } catch {
        details = null;
      }
    }
  }

  return (
    <div className="mb-4 rounded-lg border border-red-200 bg-red-50 p-4 shadow-sm">
      <div className="flex items-center justify-between">
        <span className="text-red-700 font-semibold">
          {apiError.error.message}
        </span>
        {onDismiss && (
          <button
            onClick={onDismiss}
            className="ml-4 text-xs text-red-500 hover:underline"
            aria-label="Dismiss error"
          >
            Dismiss
          </button>
        )}
      </div>
      {details && (
        <pre className="mt-2 text-xs text-red-600 bg-red-100 rounded p-2 overflow-x-auto">
          {details}
        </pre>
      )}
    </div>
  );
}; 